import React from 'react';
import { useReveal } from '../lib/useReveal';
const TOOLS = [{
  name: 'Kit Primera Sesión',
  description: 'Formularios, apertura, cierre y registro para empezar con claridad.'
}, {
  name: 'Diccionario Express',
  description: 'Preguntas organizadas para profundizar cada proceso.'
}, {
  name: 'Árbol Bio',
  description: 'Plantillas y guía rápida para detectar patrones familiares.'
}, {
  name: 'Guía de Objeciones',
  description: 'Respuestas profesionales para conversaciones y sesiones.'
}, {
  name: 'Checklist',
  description: 'Una autoevaluación para ordenar tus próximos pasos.'
}, {
  name: 'Guía rápida',
  description: 'Recursos de consulta para aplicar el método con agilidad.'
}];
export function BenefitsSection() {
  const [ref, visible] = useReveal();
  return <section className="border-t border-[#2E4F48]/15 bg-[#E8E0D3] px-4 py-10 sm:px-6 md:py-16" data-id="element-25" data-mp="y0qzrikqehut">
      <div ref={ref} className={`reveal container mx-auto max-w-5xl ${visible ? 'is-visible' : ''}`} data-id="element-26" data-mp="12yk7ig1onjx7">
        <div className="mx-auto max-w-2xl text-center" data-id="element-27" data-mp="2bct89zjjolid">
          <p className="text-xs font-bold tracking-[0.2em] text-[#C2683D]" data-id="element-28" data-mp="27csrw9cvy08o">HERRAMIENTAS PARA APLICAR</p>
          <h2 className="mt-3 font-serif text-3xl font-bold leading-tight text-[#1C3B36] md:text-5xl" data-id="element-29" data-mp="2l3nwh9gcpv6g">
            Recursos Profesionales incluidos
          </h2>
          <p className="mt-4 text-base leading-relaxed text-[#44574F]" data-id="element-30" data-mp="1sfrym1f1px83">
            No son bonos aislados: son herramientas diseñadas para acompañar tu
            práctica y ayudarte a aplicar lo aprendido.
          </p>
        </div>

        <div className="mt-8 grid gap-3 md:grid-cols-2" data-id="element-31" data-mp="22fakwoifhv3b">
          {TOOLS.map((tool, index) => <article key={tool.name} className="group flex items-start gap-4 rounded-xl border border-[#2E4F48]/20 bg-white p-4 shadow-sm transition-all hover:-translate-y-0.5 hover:border-[#C2683D]/45 hover:shadow-md" data-id="element-32" data-mp="1xdthomch1wjk" data-mpi={index}>
              <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-[#C2683D]/10 text-sm font-bold text-[#C2683D]" data-id="element-33" data-mp="3gvsi79kmh0cj">
                {String(index + 1).padStart(2, '0')}
              </span>
              <div data-id="element-34" data-mp="3pwyzhkv3if6u">
                <h3 className="font-serif text-lg font-bold text-[#1C3B36]" data-id="element-35" data-mp="3pwqoxzmg3lyt">{tool.name}</h3>
                <p className="mt-1 text-sm leading-relaxed text-[#44574F]" data-id="element-36" data-mp="3uuig2rf9n41y">{tool.description}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}